import {
  ActivatedRouteSnapshot,
  DetachedRouteHandle,
  RouteReuseStrategy,
} from '@angular/router';

export class FlagBasedReuseStrategy implements RouteReuseStrategy {
  private readonly storage = new Map<string, DetachedRouteHandle>();

  getKey(route: ActivatedRouteSnapshot): string {
    // return actual resolved url eg. /tender/123/edit etc.
    const result = route.pathFromRoot
      .map(v => v.url.map(segment => segment.toString()).join('/'))
      .join('/');

    return result;
  }

  shouldDetach(route?: ActivatedRouteSnapshot): boolean {
    return route?.routeConfig?.data?.['reusable'] ?? false;
  }

  store(route: ActivatedRouteSnapshot, handle: DetachedRouteHandle | null) {
    const routeStorageKey = this.getKey(route);
    if (routeStorageKey && handle) {
      this.storage.set(routeStorageKey, handle);
    }
  }

  shouldAttach(route: ActivatedRouteSnapshot): boolean {
    return this.storage.has(this.getKey(route));
  }

  retrieve(route: ActivatedRouteSnapshot): DetachedRouteHandle | null {
    return this.storage.get(this.getKey(route)) ?? null;
  }

  shouldReuseRoute(
    future: ActivatedRouteSnapshot,
    curr: ActivatedRouteSnapshot
  ): boolean {
    return future.routeConfig?.data?.['reusable'] ?? false;
  }
}
